
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"17.187","height":"12.085","viewBox":"0 0 17.187 12.085"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.828 1.891a2.16 2.16 0 00-1.52-1.529A51.034 51.034 0 008.594 0a51.035 51.035 0 00-6.715.361A2.16 2.16 0 00.359 1.89 22.655 22.655 0 000 6.054a22.655 22.655 0 00.359 4.164 2.127 2.127 0 001.52 1.5 51.034 51.034 0 006.715.361 51.034 51.034 0 006.715-.361 2.127 2.127 0 001.52-1.5 22.655 22.655 0 00.359-4.164 22.655 22.655 0 00-.36-4.163zM6.836 8.61V3.5l4.492 2.556z","fill":"#fff"}})])
          )
        }
      }
    